import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";
import type { NodeViewProps } from "@tiptap/react";

import { useEditorPattern, useEditorReadOnly } from "@/components/document-editor/fields-context";
import { cn } from "@/lib/utils";

export function PatternView({ node, selected }: NodeViewProps) {
	const pattern = useEditorPattern(node.attrs.patternId);
	const readOnly = useEditorReadOnly();

	return (
		<NodeViewWrapper
			data-component="document-pattern"
			data-pattern-id={node.attrs.patternId}
			className={cn("doc-pattern", selected && !readOnly && "ring-1 ring-inset ring-primary/30")}
		>
			{selected && !readOnly && (
				<div
					contentEditable={false}
					className="absolute -top-5 left-0 z-20 rounded-sm bg-primary px-1.5 py-0.5 font-sans text-xs font-semibold text-primary-foreground"
				>
					{pattern?.label ?? "Padrão removido"}
				</div>
			)}

			<NodeViewContent />
		</NodeViewWrapper>
	);
}
